import React from 'react';
import { Button, alpha, styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ViewBtn = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  borderRadius: '8px',
  padding: '6px 14px',
  boxShadow: 'none',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`,
  },
}));

interface PropsType {
  setViewMore: (view: boolean) => void;
  viewMore: boolean;
}

function ViewAction({ setViewMore, viewMore }: PropsType) {
  return (
    <ViewBtn
      onClick={() => setViewMore(!viewMore)}
      variant="contained"
      endIcon={
        viewMore ? (
          <KeyboardArrowUpIcon sx={{ color: 'inherit' }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ color: 'inherit' }} />
        )
      }
    >
      {`View ${viewMore ? 'less' : 'more'}`}
    </ViewBtn>
  );
}

export default ViewAction;
